export default __webpack_public_path__ + "static/pushfusion-intro-0b76ce4339c87ad390bfc7427a45c5a8.webm";